import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "modal-header" }
const _hoisted_2 = { class: "header-left" }
const _hoisted_3 = { class: "header-title-section" }
const _hoisted_4 = { class: "beneficiary-navigator" }
const _hoisted_5 = ["disabled"]
const _hoisted_6 = { class: "beneficiary-selector-wrapper" }
const _hoisted_7 = ["value"]
const _hoisted_8 = { class: "beneficiary-counter" }
const _hoisted_9 = ["disabled"]
const _hoisted_10 = { class: "header-controls" }
const _hoisted_11 = { class: "year-month-selector" }
const _hoisted_12 = { class: "current-period" }
const _hoisted_13 = ["value"]
const _hoisted_14 = ["value"]
const _hoisted_15 = ["disabled"]
const _hoisted_16 = { class: "modal-content" }
const _hoisted_17 = {
  key: 0,
  class: "loading-state"
}
const _hoisted_18 = {
  key: 1,
  class: "empty-state"
}
const _hoisted_19 = {
  key: 2,
  class: "calendar-grid-container"
}
const _hoisted_20 = { class: "beneficiary-info-bar" }
const _hoisted_21 = { class: "beneficiary-badge" }
const _hoisted_22 = { class: "avatar-text" }
const _hoisted_23 = { class: "badge-info" }
const _hoisted_24 = { class: "badge-name" }
const _hoisted_25 = { class: "badge-code" }
const _hoisted_26 = { class: "quick-stats" }
const _hoisted_27 = { class: "stat" }
const _hoisted_28 = { class: "stat-value" }
const _hoisted_29 = { class: "stat" }
const _hoisted_30 = { class: "stat-value" }
const _hoisted_31 = { class: "stat" }
const _hoisted_32 = { class: "stat-value" }
const _hoisted_33 = { class: "calendar-wrapper" }
const _hoisted_34 = { class: "calendar-header" }
const _hoisted_35 = { class: "calendar-body" }
const _hoisted_36 = { class: "day-header" }
const _hoisted_37 = {
  key: 0,
  class: "today-chip"
}
const _hoisted_38 = {
  key: 0,
  class: "day-schedules"
}
const _hoisted_39 = ["onMouseenter"]
const _hoisted_40 = { class: "chip-text" }
const _hoisted_41 = {
  key: 0,
  class: "more-schedules"
}
const _hoisted_42 = { class: "caregiver-list-card" }
const _hoisted_43 = { class: "caregiver-chips" }
const _hoisted_44 = ["onMouseenter"]
const _hoisted_45 = { class: "chip-name" }
const _hoisted_46 = { class: "chip-count" }
const _hoisted_47 = { class: "chip-hours" }

import { ref, computed, watch, nextTick } from 'vue';
import { homeScheduleApi } from '@/services/api';
import { mapSchedulePlanRows, normalizeScheduleDate } from '@/utils/scheduleDate';
import { downloadPdfBlob, getApiErrorMessage } from '@/utils/downloadPdf';
import LtcsMissingRequestCta from '@/components/member/request/LtcsMissingRequestCta.vue';

interface ScheduleData {
  clsp_idx: number;
  clsp_date: string;
  clsp_start_time: string;
  clsp_end_time: string;
  clsp_recipient_name: string;
  clsp_recipient_cert_number: string;
  clsp_caregiver_name: string;
  clsp_caregiver_birth: string;
  clsp_service_type: string;
  clsp_fee_name: string;
}

interface CalendarDay {
  day: number;
  date: string;
  isCurrentMonth: boolean;
  isToday: boolean;
  dayOfWeek: number;
}

interface Props {
  modelValue: boolean;
  beneficiary: any;
  beneficiaries?: any[];
  memberCode: number | string;
  bizGubun?: string;
  year?: number;
  month?: number;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'BeneficiaryCalendarModal',
  props: {
    modelValue: { type: Boolean },
    beneficiary: {},
    beneficiaries: {},
    memberCode: {},
    bizGubun: {},
    year: {},
    month: {}
  },
  emits: ["update:modelValue", "change-beneficiary"],
  setup(__props: any, { emit: __emit }) {

const SCHEDULE_LTCS_REQUEST_TYPES = ['caion_ltcs_schedule_plan'] as const;

const props = __props;
const emit = __emit;

const currentBeneficiaryIndex = ref(0);
const hoveredCaregiver = ref<string | null>(null);

const beneficiaryList = computed(() => {
  if (props.beneficiaries && props.beneficiaries.length > 0) {
    return props.beneficiaries;
  }
  return props.beneficiary ? [props.beneficiary] : [];
});

const currentBeneficiary = computed(() => {
  return beneficiaryList.value[currentBeneficiaryIndex.value] || props.beneficiary;
});

const canNavigatePrev = computed(() => currentBeneficiaryIndex.value > 0);
const canNavigateNext = computed(() => currentBeneficiaryIndex.value < beneficiaryList.value.length - 1);

const navigateBeneficiary = (delta: number) => {
  const newIndex = currentBeneficiaryIndex.value + delta;
  if (newIndex >= 0 && newIndex < beneficiaryList.value.length) {
    currentBeneficiaryIndex.value = newIndex;
    emit('change-beneficiary', currentBeneficiary.value);
    fetchScheduleData();
  }
};

const onBeneficiaryChange = () => {
  emit('change-beneficiary', currentBeneficiary.value);
  fetchScheduleData();
};

const isLoading = ref(false);
const isPdfLoading = ref(false);
const scheduleData = ref<ScheduleData[]>([]);

const today = new Date();
const selectedYear = ref(props.year || today.getFullYear());
const selectedMonth = ref(props.month || (today.getMonth() + 1));
const requestYearMonth = computed(
  () => `${selectedYear.value}${String(selectedMonth.value).padStart(2, '0')}`
);

const dialogVisible = computed({
  get: () => props.modelValue,
  set: (value) => emit('update:modelValue', value)
});

const yearOptions = computed(() => {
  const currentYear = new Date().getFullYear();
  return [currentYear - 2, currentYear - 1, currentYear, currentYear + 1];
});

const weekDays = ['일', '월', '화', '수', '목', '금', '토'];

const calendarDays = computed<CalendarDay[]>(() => {
  const year = selectedYear.value;
  const month = selectedMonth.value;

  const firstDay = new Date(year, month - 1, 1);
  const startDay = new Date(firstDay);
  startDay.setDate(startDay.getDate() - firstDay.getDay());

  const days: CalendarDay[] = [];
  const current = new Date(startDay);
  const todayStr = formatDateStr(today);

  for (let i = 0; i < 42; i++) {
    const isCurrentMonth = current.getMonth() === month - 1;
    const dateStr = formatDateStr(current);

    days.push({
      day: current.getDate(),
      date: dateStr,
      isCurrentMonth,
      isToday: dateStr === todayStr,
      dayOfWeek: current.getDay()
    });

    current.setDate(current.getDate() + 1);
  }

  return days;
});

const monthlyStats = computed(() => {
  const uniqueDays = new Set(scheduleData.value.map(s => s.clsp_date));
  const uniqueCaregivers = new Set(scheduleData.value.map(s => s.clsp_caregiver_name));

  let totalMinutes = 0;
  scheduleData.value.forEach(s => {
    totalMinutes += calculateMinutes(s.clsp_start_time, s.clsp_end_time);
  });

  return {
    totalDays: uniqueDays.size,
    totalHours: formatHours(totalMinutes),
    caregiverCount: uniqueCaregivers.size
  };
});

const caregiverList2 = computed(() => {
  const cgData: Record<string, { count: number; minutes: number }> = {};

  scheduleData.value.forEach(s => {
    if (!cgData[s.clsp_caregiver_name]) {
      cgData[s.clsp_caregiver_name] = { count: 0, minutes: 0 };
    }
    cgData[s.clsp_caregiver_name].count++;
    cgData[s.clsp_caregiver_name].minutes += calculateMinutes(s.clsp_start_time, s.clsp_end_time);
  });

  return Object.entries(cgData)
    .map(([name, data]) => ({
      name,
      count: data.count,
      hours: formatHours(data.minutes)
    }))
    .sort((a, b) => b.count - a.count);
});

const caregiverColors: Record<string, string> = {};
const colorPalette = [
  '#3b82f6', '#ef4444', '#22c55e', '#a855f7', '#f97316',
  '#14b8a6', '#ec4899', '#4f46e5', '#eab308', '#64748b'
];

const getCaregiverColor = (name: string): string => {
  if (!caregiverColors[name]) {
    const idx = Object.keys(caregiverColors).length % colorPalette.length;
    caregiverColors[name] = colorPalette[idx];
  }
  return caregiverColors[name];
};

const formatDateStr = (date: Date): string => {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, '0');
  const d = String(date.getDate()).padStart(2, '0');
  return `${y}-${m}-${d}`;
};

const formatTime = (time: string | undefined): string => {
  if (!time) return '';
  const str = time.toString().replace(/[^0-9]/g, '');
  if (str.length >= 4) {
    return `${str.slice(0, 2)}:${str.slice(2, 4)}`;
  }
  return time;
};

const calculateMinutes = (startTime: string, endTime: string): number => {
  const start = formatTime(startTime).split(':');
  const end = formatTime(endTime).split(':');
  if (start.length < 2 || end.length < 2) return 0;

  const startMinutes = parseInt(start[0]) * 60 + parseInt(start[1]);
  const endMinutes = parseInt(end[0]) * 60 + parseInt(end[1]);
  return Math.max(0, endMinutes - startMinutes);
};

const formatHours = (minutes: number): string => {
  const hours = Math.floor(minutes / 60);
  const mins = minutes % 60;
  if (mins > 0) return `${hours}h ${mins}m`;
  return `${hours}h`;
};

const maskCode = (code: string | undefined): string => {
  if (!code || code.length < 3) return code || '-';
  return code.slice(0, -3) + '***';
};

const getDaySchedules = (dateStr: string): ScheduleData[] => {
  return scheduleData.value.filter((s) => normalizeScheduleDate(s.clsp_date) === dateStr);
};

const changeMonth = (delta: number) => {
  let newMonth = selectedMonth.value + delta;
  let newYear = selectedYear.value;

  if (newMonth > 12) {
    newMonth = 1;
    newYear++;
  } else if (newMonth < 1) {
    newMonth = 12;
    newYear--;
  }

  selectedMonth.value = newMonth;
  selectedYear.value = newYear;
  fetchScheduleData();
};

const fetchScheduleData = async () => {
  const ben = currentBeneficiary.value;
  if (!props.memberCode || !ben?.patient_code) return;

  try {
    isLoading.value = true;
    const yearMonth = `${selectedYear.value}${String(selectedMonth.value).padStart(2, '0')}`;

    let res = await homeScheduleApi.getBeneficiarySchedule(
      props.memberCode,
      ben.patient_code,
      yearMonth,
      props.bizGubun || undefined
    );

    if (
      res.data.success &&
      (!res.data.data || res.data.data.length === 0) &&
      props.bizGubun
    ) {
      res = await homeScheduleApi.getBeneficiarySchedule(
        props.memberCode,
        ben.patient_code,
        yearMonth,
        undefined
      );
    }

    if (res.data.success) {
      scheduleData.value = mapSchedulePlanRows(res.data.data || []);
    } else {
      scheduleData.value = [];
    }
  } catch (error: any) {
    const message = error.response?.data?.message || error.message || '일정 조회에 실패했습니다.';
    const status = error.response?.status || '';
    console.error('일정 데이터 조회 오류:', error);
    alert(`일정 조회 실패: ${message}${status ? ` (${status})` : ''}`);
    scheduleData.value = [];
  } finally {
    isLoading.value = false;
  }
};

const printSchedulePdf = async () => {
  const ben = currentBeneficiary.value;
  if (!props.memberCode || !ben?.patient_code) return;

  try {
    isPdfLoading.value = true;
    const yearMonth = `${selectedYear.value}${String(selectedMonth.value).padStart(2, '0')}`;

    let res = await homeScheduleApi.downloadBeneficiaryPdf(
      props.memberCode,
      ben.patient_code,
      yearMonth,
      props.bizGubun || undefined
    );
    if (res.status === 404 && props.bizGubun) {
      res = await homeScheduleApi.downloadBeneficiaryPdf(
        props.memberCode,
        ben.patient_code,
        yearMonth,
        undefined
      );
    }

    downloadPdfBlob(res.data, `일정표_${ben.patient_name}_${yearMonth}.pdf`);
  } catch (error: unknown) {
    const message = await getApiErrorMessage(error, '일정표 PDF 출력에 실패했습니다.');
    console.error('PDF 출력 오류:', error);
    alert(`일정표 PDF 출력 실패: ${message}`);
  } finally {
    isPdfLoading.value = false;
  }
};

const close = () => {
  dialogVisible.value = false;
};

watch(dialogVisible, async (visible) => {
  if (visible) {
    selectedYear.value = props.year || today.getFullYear();
    selectedMonth.value = props.month || (today.getMonth() + 1);

    if (props.beneficiaries && props.beneficiaries.length > 0 && props.beneficiary) {
      const idx = props.beneficiaries.findIndex(b =>
        b.patient_code === props.beneficiary.patient_code
      );
      currentBeneficiaryIndex.value = idx >= 0 ? idx : 0;
    } else {
      currentBeneficiaryIndex.value = 0;
    }

    await nextTick();
    if (currentBeneficiary.value?.patient_code) {
      await fetchScheduleData();
    }
  }
});

watch([selectedYear, selectedMonth], async ([newYear, newMonth], [oldYear, oldMonth]) => {
  if (dialogVisible.value && (newYear !== oldYear || newMonth !== oldMonth)) {
    await fetchScheduleData();
  }
});

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_avatar = _resolveComponent("v-avatar")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_dialog, {
    modelValue: dialogVisible.value,
    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((dialogVisible).value = $event)),
    "max-width": "1200px",
    scrollable: "",
    persistent: ""
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card, { class: "beneficiary-calendar-modal" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_v_icon, {
                size: "24",
                color: "white"
              }, {
                default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                  _createTextVNode("mdi-calendar-account", -1)
                ]))]),
                _: 1
              }),
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("button", {
                    class: "nav-btn-circle",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (navigateBeneficiary(-1))),
                    disabled: !canNavigatePrev.value,
                    title: "이전 수급자"
                  }, [
                    _createVNode(_component_v_icon, { size: "18" }, {
                      default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                        _createTextVNode("mdi-chevron-left", -1)
                      ]))]),
                      _: 1
                    })
                  ], 8, _hoisted_5),
                  _createElementVNode("div", _hoisted_6, [
                    _withDirectives(_createElementVNode("select", {
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((currentBeneficiaryIndex).value = $event)),
                      class: "beneficiary-select",
                      onChange: onBeneficiaryChange
                    }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(beneficiaryList.value, (ben, idx) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: ben.patient_code,
                          value: idx
                        }, _toDisplayString(ben.patient_name), 9, _hoisted_7))
                      }), 128))
                    ], 544), [
                      [_vModelSelect, currentBeneficiaryIndex.value]
                    ]),
                    _createElementVNode("span", _hoisted_8, _toDisplayString(currentBeneficiaryIndex.value + 1) + " / " + _toDisplayString(beneficiaryList.value.length), 1)
                  ]),
                  _createElementVNode("button", {
                    class: "nav-btn-circle",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (navigateBeneficiary(1))),
                    disabled: !canNavigateNext.value,
                    title: "다음 수급자"
                  }, [
                    _createVNode(_component_v_icon, { size: "18" }, {
                      default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                        _createTextVNode("mdi-chevron-right", -1)
                      ]))]),
                      _: 1
                    })
                  ], 8, _hoisted_9)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("button", {
                  class: "nav-btn",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (changeMonth(-1)))
                }, [
                  _createVNode(_component_v_icon, { size: "18" }, {
                    default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
                      _createTextVNode("mdi-chevron-left", -1)
                    ]))]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((selectedYear).value = $event)),
                    class: "year-select"
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(yearOptions.value, (y) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: y,
                        value: y
                      }, _toDisplayString(y) + "년", 9, _hoisted_13))
                    }), 128))
                  ], 512), [
                    [_vModelSelect, selectedYear.value]
                  ]),
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((selectedMonth).value = $event)),
                    class: "month-select"
                  }, [
                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(12, (m) => {
                      return _createElementVNode("option", {
                        key: m,
                        value: m
                      }, _toDisplayString(m) + "월", 9, _hoisted_14)
                    }), 64))
                  ], 512), [
                    [_vModelSelect, selectedMonth.value]
                  ])
                ]),
                _createElementVNode("button", {
                  class: "nav-btn",
                  onClick: _cache[6] || (_cache[6] = ($event: any) => (changeMonth(1)))
                }, [
                  _createVNode(_component_v_icon, { size: "18" }, {
                    default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
                      _createTextVNode("mdi-chevron-right", -1)
                    ]))]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("button", {
                class: "pdf-btn",
                onClick: printSchedulePdf,
                disabled: isPdfLoading.value || scheduleData.value.length === 0,
                title: "일정표 PDF 출력"
              }, [
                _createVNode(_component_v_icon, {
                  size: "18",
                  color: "white"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(isPdfLoading.value ? 'mdi-loading mdi-spin' : 'mdi-file-pdf-box'), 1)
                  ]),
                  _: 1
                }),
                _cache[15] || (_cache[15] = _createElementVNode("span", null, "PDF", -1))
              ], 8, _hoisted_15),
              _createElementVNode("button", {
                class: "close-btn",
                onClick: close
              }, [
                _createVNode(_component_v_icon, {
                  size: "20",
                  color: "white"
                }, {
                  default: _withCtx(() => [...(_cache[16] || (_cache[16] = [
                    _createTextVNode("mdi-close", -1)
                  ]))]),
                  _: 1
                })
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_16, [
            (isLoading.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                  _createVNode(_component_v_progress_circular, {
                    indeterminate: "",
                    color: "#0d47a1",
                    size: "40"
                  }),
                  _cache[17] || (_cache[17] = _createElementVNode("span", null, "일정을 불러오는 중...", -1))
                ]))
              : (scheduleData.value.length === 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                    _createVNode(_component_v_icon, {
                      size: "56",
                      color: "#cbd5e1"
                    }, {
                      default: _withCtx(() => [...(_cache[18] || (_cache[18] = [
                        _createTextVNode("mdi-calendar-blank", -1)
                      ]))]),
                      _: 1
                    }),
                    _cache[19] || (_cache[19] = _createElementVNode("h3", null, "일정 데이터가 없습니다", -1)),
                    _createElementVNode("p", null, _toDisplayString(selectedYear.value) + "년 " + _toDisplayString(selectedMonth.value) + "월에 " + _toDisplayString(currentBeneficiary.value?.patient_name) + "님의 일정이 없습니다.", 1),
                    _createVNode(LtcsMissingRequestCta, {
                      "member-code": __props.memberCode,
                      "biz-gubun": __props.bizGubun,
                      "year-month": requestYearMonth.value,
                      types: SCHEDULE_LTCS_REQUEST_TYPES,
                      onUpdated: fetchScheduleData
                    }, null, 8, ["member-code", "biz-gubun", "year-month"])
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_19, [
                    _createElementVNode("div", _hoisted_20, [
                      _createElementVNode("div", _hoisted_21, [
                        _createVNode(_component_v_avatar, {
                          size: "40",
                          color: "#1e3a5f"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("span", _hoisted_22, _toDisplayString(currentBeneficiary.value?.patient_name?.charAt(0)), 1)
                          ]),
                          _: 1
                        }),
                        _createElementVNode("div", _hoisted_23, [
                          _createElementVNode("span", _hoisted_24, _toDisplayString(currentBeneficiary.value?.patient_name), 1),
                          _createElementVNode("span", _hoisted_25, _toDisplayString(maskCode(currentBeneficiary.value?.patient_code)), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_26, [
                        _createElementVNode("div", _hoisted_27, [
                          _createElementVNode("span", _hoisted_28, _toDisplayString(monthlyStats.value.totalDays), 1),
                          _cache[20] || (_cache[20] = _createElementVNode("span", { class: "stat-label" }, "서비스일", -1))
                        ]),
                        _createElementVNode("div", _hoisted_29, [
                          _createElementVNode("span", _hoisted_30, _toDisplayString(monthlyStats.value.totalHours), 1),
                          _cache[21] || (_cache[21] = _createElementVNode("span", { class: "stat-label" }, "총 시간", -1))
                        ]),
                        _createElementVNode("div", _hoisted_31, [
                          _createElementVNode("span", _hoisted_32, _toDisplayString(monthlyStats.value.caregiverCount), 1),
                          _cache[22] || (_cache[22] = _createElementVNode("span", { class: "stat-label" }, "담당 종사자", -1))
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_33, [
                      _createElementVNode("div", _hoisted_34, [
                        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(weekDays, (day) => {
                          return _createElementVNode("div", {
                            class: _normalizeClass(["weekday", { sunday: day === '일', saturday: day === '토' }]),
                            key: day
                          }, _toDisplayString(day), 3)
                        }), 64))
                      ]),
                      _createElementVNode("div", _hoisted_35, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(calendarDays.value, (day, idx) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: idx,
                            class: _normalizeClass(["calendar-day", { 
                    'other-month': !day.isCurrentMonth,
                    'today': day.isToday,
                    'has-schedule': getDaySchedules(day.date).length > 0
                  }])
                          }, [
                            _createElementVNode("div", _hoisted_36, [
                              _createElementVNode("div", {
                                class: _normalizeClass(["day-number", { sunday: day.dayOfWeek === 0, saturday: day.dayOfWeek === 6 }])
                              }, _toDisplayString(day.day), 3),
                              (day.isToday)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_37, "TODAY"))
                                : _createCommentVNode("", true)
                            ]),
                            (day.isCurrentMonth)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getDaySchedules(day.date).slice(0, 4), (schedule, sIdx) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                      key: sIdx,
                                      class: _normalizeClass(["schedule-chip-inline", { 'highlighted': hoveredCaregiver.value === schedule.clsp_caregiver_name }]),
                                      style: _normalizeStyle({ borderLeftColor: getCaregiverColor(schedule.clsp_caregiver_name) }),
                                      onMouseenter: ($event: any) => (hoveredCaregiver.value = schedule.clsp_caregiver_name),
                                      onMouseleave: _cache[7] || (_cache[7] = ($event: any) => (hoveredCaregiver.value = null))
                                    }, [
                                      _createElementVNode("span", _hoisted_40, _toDisplayString(schedule.clsp_caregiver_name) + " " + _toDisplayString(formatTime(schedule.clsp_start_time)) + "-" + _toDisplayString(formatTime(schedule.clsp_end_time)), 1)
                                    ], 46, _hoisted_39))
                                  }), 128)),
                                  (getDaySchedules(day.date).length > 4)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_41, " +" + _toDisplayString(getDaySchedules(day.date).length - 4), 1))
                                    : _createCommentVNode("", true)
                                ]))
                              : _createCommentVNode("", true)
                          ], 2))
                        }), 128))
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_42, [
                      _createElementVNode("h4", null, [
                        _createVNode(_component_v_icon, {
                          size: "18",
                          color: "#1e3a5f"
                        }, {
                          default: _withCtx(() => [...(_cache[23] || (_cache[23] = [
                            _createTextVNode("mdi-account-hard-hat", -1)
                          ]))]),
                          _: 1
                        }),
                        _cache[24] || (_cache[24] = _createTextVNode(" 담당 종사자 목록 ", -1))
                      ]),
                      _createElementVNode("div", _hoisted_43, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(caregiverList2.value, (cg) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: cg.name,
                            class: _normalizeClass(["caregiver-chip", { 'highlighted': hoveredCaregiver.value === cg.name }]),
                            style: _normalizeStyle({ borderLeftColor: getCaregiverColor(cg.name) }),
                            onMouseenter: ($event: any) => (hoveredCaregiver.value = cg.name),
                            onMouseleave: _cache[8] || (_cache[8] = ($event: any) => (hoveredCaregiver.value = null))
                          }, [
                            _createElementVNode("div", {
                              class: "chip-color",
                              style: _normalizeStyle({ backgroundColor: getCaregiverColor(cg.name) })
                            }, null, 4),
                            _createElementVNode("span", _hoisted_45, _toDisplayString(cg.name), 1),
                            _createElementVNode("span", _hoisted_46, _toDisplayString(cg.count) + "회", 1),
                            _createElementVNode("span", _hoisted_47, _toDisplayString(cg.hours), 1)
                          ], 46, _hoisted_44))
                        }), 128))
                      ])
                    ])
                  ]))
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})